const defineSmartGetter = <O extends object, K extends PropertyKey, V extends unknown>(
  obj: O,
  key: K,
  valueFn: () => V
): O & { readonly [Key in K]: V } => {
  Object.defineProperty(obj, key, {
    get: () => {
      delete (obj as Record<K, V>)[key];
      (obj as Record<K, V>)[key] = valueFn();
      return (obj as Record<K, V>)[key];
    },
    enumerable: true,
    configurable: true
  });

  return obj as O & { readonly [Key in K]: V };
};

export default defineSmartGetter;
